import { createAppStore } from '@store/createAppStore';
import { IFuelSurchargeStore } from '@store/customers/customerDetails/fuelSurcharge';

const [fuelSurchargeStore, setFuelSurchargeStore] =
  createAppStore<IFuelSurchargeStore>(
    {
      fuelSurchargeData: null,
      isLoading: false,
      errors: [],
    },
    'fuelSurchargeStore',
  );

export { fuelSurchargeStore, setFuelSurchargeStore };
